var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12074_9375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1004 19.5206V14.7206C10.1004 10.9014 11.6175 7.23874 14.3181 4.53822C17.0186 1.8377 20.6813 0.320557 24.5004 0.320557C28.3195 0.320557 31.9822 1.8377 34.6827 4.53822C37.3833 7.23874 38.9004 10.9014 38.9004 14.7206V19.5206H41.3004C42.5734 19.5206 43.7943 20.0263 44.6945 20.9264C45.5947 21.8266 46.1004 23.0475 46.1004 24.3206V43.5206C46.1004 44.7936 45.5947 46.0145 44.6945 46.9147C43.7943 47.8148 42.5734 48.3206 41.3004 48.3206H7.70039C6.42735 48.3206 5.20645 47.8148 4.30628 46.9147C3.4061 46.0145 2.90039 44.7936 2.90039 43.5206V24.3206C2.90039 21.6806 5.06039 19.5206 7.70039 19.5206H10.1004ZM22.1004 35.6726V41.1206H26.9004V35.6726C27.8155 35.1442 28.5307 34.3287 28.935 33.3525C29.3394 32.3763 29.4103 31.2939 29.1368 30.2733C28.8634 29.2527 28.2607 28.3508 27.4224 27.7075C26.5842 27.0643 25.557 26.7156 24.5004 26.7156C23.4437 26.7156 22.4166 27.0643 21.5783 27.7075C20.74 28.3508 20.1374 29.2527 19.8639 30.2733C19.5905 31.2939 19.6614 32.3763 20.0658 33.3525C20.4701 34.3287 21.1853 35.1442 22.1004 35.6726ZM17.3004 14.7206V19.5206H31.7004V14.7206C31.7004 12.811 30.9418 10.9797 29.5916 9.62939C28.2413 8.27913 26.41 7.52056 24.5004 7.52056C22.5908 7.52056 20.7595 8.27913 19.4092 9.62939C18.059 10.9797 17.3004 12.811 17.3004 14.7206Z",
    fill: "url(#paint0_linear_12074_9375)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12074_9375",
    x1: 24.5004,
    y1: 0.320557,
    x2: 24.5004,
    y2: 48.3206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12074_9375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.320557)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGold);
export default __webpack_public_path__ + "static/media/lock_gold.39111b60e9271461ba1c2d00e1a38a36.svg";
export { ForwardRef as ReactComponent };